module.exports = __webpack_public_path__ + "img/peanuts.3950d647.svg";